var themes = {
    light: { name: "light", class: "" },
    dark: { name: "dark", class: "dark-mode" },
};
export var setLightModeCss = function () { return document.body.classList.remove(themes.dark.class); };
export var setDarkModeCss = function () { return document.body.classList.add(themes.dark.class); };
